import { FunctionComponent } from "react";

import type { StickyNavCommentMeta } from "@framework/comments/comments.types";
import { useCommentCountId } from "@framework/comments/use-comment-count-id";
import { getIn5CycloneCommentCountId } from "@framework/in5/in5-comment-ids";
import CommentCount from "@voxmedia/duet-ui/components/meta/CommentCount";

interface Props extends StickyNavCommentMeta {
  className?: string;
}

/** Resolves countId from the mounted comment provider for sticky nav. */
const StickyNavCommentCount: FunctionComponent<Props> = ({
  className,
  nodeArgs,
  url,
  authorName,
  headline,
  contentType,
}) => {
  const countIdFromProvider = useCommentCountId(nodeArgs);
  const countId =
    contentType === "in5game" && nodeArgs.nodeId
      ? getIn5CycloneCommentCountId({ uuid: nodeArgs.nodeId })
      : countIdFromProvider;

  return (
    <CommentCount
      className={className}
      countId={countId}
      url={url}
      authorName={authorName}
      headline={headline}
      contentType={contentType}
      noText
      variant="stickyNav"
    />
  );
};

export default StickyNavCommentCount;
